import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { logCrossOriginFramedEvent } from "./lib/amplitude-utils";
import Loader from "./Loader";

export const isIframeSameTLDPlusOne = () => {
  try {
    const iframeHostname = window.self.location.hostname;
    const topLevelHostname = window.top.location.hostname;

    // Extract the top-level domain for comparison
    const getTopLevelDomainPlusOne = (hostname) => {
      const parts = hostname.split('.');
      if (parts.length > 1) {
        return parts.slice(-2).join('.'); // Returns "example.com" from "sub.example.com"
      }
      return hostname; // For single-part hostnames like "localhost"
    };
    const iframeTLDPlusOne = getTopLevelDomainPlusOne(iframeHostname);
    const topLevelTLDPlusOne = getTopLevelDomainPlusOne(topLevelHostname);
    return iframeTLDPlusOne === topLevelTLDPlusOne;
  } catch (error) {
    // This catch block handles the "Same Origin Policy" security error
    // if the iframe is on a different origin, preventing access to its location.
    return false; // Cannot determine if same TLD+1 due to security restrictions
  }
};

const FramingContext = React.createContext({});

export const useFramingContext = () => React.useContext(FramingContext);

export const FrameRestricter = ({ children }) => {
  const [ displayBody, setIsDisplayBody ] = React.useState(
    window.self === window.top
  );
  const [ framingAllowed, setIsFramingAllowed ] = React.useState(false);
  React.useEffect(() => {
    async function handleBodyDisplay() {
      if (framingAllowed && window.self !== window.top) {
        await logCrossOriginFramedEvent({
          parentOrigin: document.referrer,
        });
      }
      if (
        window.self === window.top
        || framingAllowed
        || isIframeSameTLDPlusOne()
      ) {
        setIsDisplayBody(true);
      }
    }
    handleBodyDisplay();
  }, [ framingAllowed ]);

  const framingContextProviderValue = useMemo(
    () => ({
      allowFraming: () => {
        setIsFramingAllowed(true);
      },
    }),
    []
  );

  return (
    <div>
      {!displayBody && (<Loader />)}
      <div style={{ display: displayBody ? "block" : "none" }}>
        <FramingContext.Provider value={framingContextProviderValue}>
          {children}
        </FramingContext.Provider>
      </div>
    </div>
  );
};

FrameRestricter.propTypes = {
  children: PropTypes.node.isRequired,
};
